/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRosterEditShiftCtrl
 */
angular.module('mercury.modules.time.roster')
.controller('TimeRosterEditShiftCtrl', ["$filter", "reporttime", "$scope", "$stateParams", "data", "TimeConstants", function($filter, reporttime, $scope, $stateParams, data, TimeConstants) {
  $scope.areAllShiftsLocked = true;

  var reportStateParams = $stateParams.report ? JSON.parse($stateParams.report) : {};

  if ($scope.isTemplate) {
    $scope.view = reportStateParams.period || 'week';
    $scope.shifts = $scope.view == 'day' ? [data.shifts] : data.rosterCells.shifts;
    $scope.areAllShiftsLocked = false;

  } else {
    if (reporttime.reportType() == 'day') {
      if (data.shifts.datestampLocked == null) {
        $scope.areAllShiftsLocked = false;
      }
      $scope.shifts = [data.shifts];
      $scope.view = 'day';
    } else {
      data.rosterCells.shifts.forEach(function(rosteredShift) {
        if (rosteredShift.datestampLocked == null) {
          $scope.areAllShiftsLocked = false;
        }
      });

      $scope.shifts = data.rosterCells.shifts;
      $scope.view = 'week';
    }
  }



  $scope.roles = data.roles;
  $scope.activeRoles = $filter('filter')($scope.roles, function(role) {
    // A role is active if it hasn't been deleted or the role is used on a shift.
    return role.datestampDeleted === null || $filter('filter')($scope.shifts, {roleId: role.id}).length !== 0;
  });

  $scope.allStaff = data.staff;
  $scope.staffMember = $filter('filter')(data.staff, {id: $scope.shifts[0].staffMemberId})[0];

  var deletedShifts = [];
  var deletedBreaks = [];
  var breaksOverlap = Array($scope.shifts.length).fill(false);

  $scope.openIndex = (typeof index != 'undefined') ? index : 0;
  $scope.save = data.saveCb;

  /**
   * Helper for use with ng-class, returns a background colour tied to the role id.
   *
   * Note this is not currently used but remains here as it may be needed again.
   *
   * @param {*} roleId
   * @returns
   */
  $scope.getRoleClass = function(roleId) {
    var NUM_CSS_ROLE_COLOURS = 13; // this variable needs to match the number of role-<num> rules defined in loaded.less
    return 'role-' + ($scope.roles.findIndex(function(role) {
      return role.id === roleId;
    }) % NUM_CSS_ROLE_COLOURS + 1);
  };

  $scope.deleteShift = function() {
    if ($scope.reportType == 'week') {
      // If the shift was saved previously, update the datestampDeleted, otherwise just remove it.
      if ($scope.shifts[$scope.openIndex].id) {
        deletedShifts.push($scope.shifts[$scope.openIndex]);
      }

      $scope.shifts.splice($scope.openIndex, 1);

      if ($scope.openIndex >= $scope.shifts.length) {
        $scope.openIndex--;
      }
    } else {
      $scope.shifts[0].deleted = true;
      $scope.save();
    }
  };

  var staffDropDownWidth = function() {
    jQuery('#rds_temp_select_option').html(jQuery('.staff-dropdown option:selected').text());
    jQuery('.staff-dropdown').width($('#rds_temp_select').width() - (25 - 8));
  };

  $scope.setRole = function(shift) {
    shift.roleName = $filter('filter')($scope.roles, {id: shift.roleId})[0].name;
  };

  $scope.setStaff = function() {
    staffDropDownWidth();
    $scope.shifts[0].staffMemberId = $scope.staffMember.id;
  };

  $scope.addShift = function() {
    var newStart = moment(data.startTime);
    if ($scope.shifts.length !== 0) {
      newStart = moment($scope.shifts[$scope.shifts.length - 1].clockoutTime);

      if (newStart.clone().add(3, 'hours').isAfter(moment(data.startTime).add(1, 'day'))) {
        newStart = moment(data.startTime);
      }
    }

    $scope.shifts.push({
      roleId: $scope.staffMember.defaultMemberRoleRoleId,
      roleName: $scope.staffMember.defaultMemberRoleRoleName,
      staffMemberId: $scope.staffMember.id,
      clockinTime: newStart.format(),
      clockoutTime: newStart.add(3, 'hours').format(),
      breaks: []
    });

    $scope.openIndex = $scope.shifts.length - 1;
  };

  /**
   * Method the goes through all breaks in a shift array and compares every break against each other to check if the overlap
   * @param {int} shiftIndex, the index of the shift that related breaks are in
   * @returns true if the breaks overlap, false if not
   */
  $scope.breaksOverlap = function(shiftIndex) {
    var shiftBreaks = $scope.shifts[shiftIndex].breaks;

    // If there is not breaks then none overlap
    if (!shiftBreaks) {
      return false;
    }

    for (var i = 0; i < shiftBreaks.length; i++) {
      var breakA = shiftBreaks[i];

      // Compare breakA against all other breaks to see if it overlaps
      for (var j = 0; j < shiftBreaks.length; j++) {
        // Don't compare a break against itself
        if (j == i) {
          break;
        }

        var breakB = shiftBreaks[j];

        // Validate that the break does not overlap another break
        if (breakA.breakStart < breakB.breakEnd && breakA.breakEnd > breakB.breakStart) {
          breaksOverlap[shiftIndex] = true;
          return true;
        }
      }
    }
    breaksOverlap[shiftIndex] = false;
    return false;
  };

  /**
   * Calculates the break duration
   * @param {*} breakStart, the start time of a break
   * @param {*} breakEnd, the end time of a break
   * @returns the break duration in minutes
   */
  $scope.calculateBreakDuration = function(breakStart, breakEnd) {
    return moment(breakEnd).diff(moment(breakStart), 'minutes');
  };

  /**
   * Validates a given break and sets its validityError flag
   * @param {break} shiftBreak, the break to be validated
   * @param {shift} shift , the shift the break is being applied to
   * @returns true if break is valid, false if not
   */
  $scope.validateBreak = function(shiftBreak, shift) {

    // If there is no breaks then valid
    if (!shift.breaks) {
      return true;
    }

    shiftBreak.validityError = true;
    if (shiftBreak.breakStart < shift.clockinTime) {
      return false;
    } else if (shiftBreak.breakEnd > shift.clockoutTime) {
      return false;
    } else if (shiftBreak.breakStart > shiftBreak.breakEnd) {
      return false;
    } else {
      shiftBreak.validityError = false;
      return true;
    }
  };

  /**
   * Gets halfway through the shift to intialise a breakStart value
   * @param {shift} shift, the shift that the break is being applied to
   * @returns {moment} moment, representing the time half way through the shift
   */
  var initialBreakStartTime = function(shift) {
    var duration = moment.duration(moment(shift.clockoutTime).diff(moment(shift.clockinTime)));
    var halfway = Math.round(duration.asHours() / 2);
    return moment(shift.clockinTime).add(halfway, 'hours');
  };

  /**
   * Adds a break to the a shift's break array
   * @param {int} $index, the index of the shift to add the break to
   */
  $scope.addBreak = function($index) {
    var shift = $scope.shifts[$index];
    var startTime = initialBreakStartTime(shift);
    var newBreak = {
      shiftId: shift.id,
      type: TimeConstants.ShiftType.Roster,
      breakStart: startTime.format(),
      breakEnd: startTime.add(30, 'minutes').format(),
      paid: false
    };

    $scope.shifts[$index].breaks.push(newBreak);
  };

  /**
   * Removes a break from a shift
   * @param {int} breakIndex, the index of the break in its array
   * @param {shift} shiftToDeleteFrom, the shift to delete the break from
   */
  $scope.deleteBreak = function(breakIndex, shiftToDeleteFrom) {
    var shiftIndex = 0;

    // If the we are in week view then there can be multiple shifts
    // thus we need to find the index of the shift we want to remove the
    // break from
    if ($scope.reportType == 'week') {
      shiftIndex = $scope.shifts.findIndex(function(shift) {
        return shift.id == shiftToDeleteFrom.id;
      });
    }

    // If break has an Id then is saved in the DB thus the deletion process
    // set the 'deletedAt' field and add it the the deletedBreaks array
    if ($scope.shifts[shiftIndex].breaks[breakIndex].id) {
      var deletedBreak = $scope.shifts[shiftIndex].breaks[breakIndex];

      deletedBreak.deletedAt = moment().format();
      deletedBreak.shiftIndex = shiftIndex;

      deletedBreaks.push(deletedBreak);
    }

    // Remove the break from the array so it is not displayed in UI
    $scope.shifts[shiftIndex].breaks.splice(breakIndex, 1);
  };

  /**
   * Evaluates whether the save button should be disabled or not.
   * Currently only based on on whether breaks are valid
   * @returns true if the elements in dialog are valid, false if not
   */
  $scope.disableSave = function() {
    var noOverlap = breaksOverlap.every(function(element) {
      return element === false;
    });

    if (!noOverlap) {
      return true;
    }

    // Goes through every break in newClock and re-validates the break
    // If the validateBreak methods returns false at any point then disable then disable the button
    for (var shiftIndex in $scope.shifts) {
      var shift = $scope.shifts[shiftIndex];

      for (var breakIndex in shift.breaks) {
        var shiftBreak = shift.breaks[breakIndex];
        var result = $scope.validateBreak(shiftBreak, shift);

        // If break not valid disable button
        if (!result) {
          return true;
        }
      }
    }

    return false;
  };

  $scope.save = function() {
    // Push deleted breaks back into the shifts
    angular.forEach(deletedBreaks, function(deletedBreak) {
      $scope.shifts[deletedBreak.shiftIndex].breaks.push(deletedBreak);
    });

    if ($scope.reportType == 'week') {
      angular.forEach(deletedShifts, function(deletedShift) {
        deletedShift.deleted = true;
        $scope.shifts.push(deletedShift);
      });

      $scope.$close($scope.shifts);
    } else {
      $scope.$close($scope.shifts[0]);
    }
  };

  setTimeout(function() {
    staffDropDownWidth();
  }, 50);

}]);
